export default __webpack_public_path__ + "media/icons/live-icon-active-780a4bc2.svg";